import { IStyleProps } from './Interface'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { rgb } from 'polished'

const darken = {
  white: rgb(200, 200, 200),
  lightOrange: rgb(227, 110, 48),
  orange: rgb(242, 83, 35),
  yellow: rgb(253, 158, 42),
  purple: rgb(106, 50, 146),
  lightGrey: rgb(199, 199, 199),
  grey: rgb(205, 203, 219),
  darkGrey: rgb(185, 183, 190),
  lightBlue: rgb(24, 124, 191)
}

export default makeStyles<Theme, IStyleProps>(theme => ({
  root: {
    padding: '5px 15px',
    backgroundColor: ({ bgColor, flat }) => (!flat ? theme.palette.common[bgColor] : 'none'),
    color: ({ fontColor, flat, bgColor }) => (!flat ? fontColor : bgColor),
    textTransform: ({ textTransform }) => textTransform,
    '&:hover': {
      background: ({ bgColor, flat }) => (!flat ? darken[bgColor] : 'none'),
      color: ({ bgColor, flat, fontColor }) => (!flat ? fontColor : darken[bgColor])
    },
    '&:disabled': {
      '&:hover': {
        cursor: 'not-allowed !important'
      }
    }
  },
  flat: {}
}))
